/* Prozone B2B — pz-account.js
   Espace compte : navigation par sections, réassort agrégé depuis l'historique,
   recommande d'une commande passée. Dépend de window.pzB2B (pz-b2b-config). */
(function () {
  'use strict';

  var root = document.querySelector('.pz-acc');
  if (!root) return;

  var CFG = window.pzB2B || {};
  var R = CFG.routes || {};
  var fmt = new Intl.NumberFormat(CFG.locale === 'de' ? 'de-CH' : (CFG.locale === 'en' ? 'en-CH' : 'fr-CH'), {
    style: 'currency', currency: CFG.currency || 'CHF'
  });
  function money(c) { return fmt.format((c || 0) / 100); }

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ──────────── Navigation par sections ──────────── */

  /* `commande` (singulier) = le détail d'une commande. Sans lui dans cette
     liste blanche, ?v=commande retombait sur le tableau de bord — et c'est le
     même piège pour toute section ajoutée au gabarit sans l'ajouter ici. */
  var SECTIONS = ['dashboard', 'commandes', 'factures', 'commande', 'facture', 'entreprise', 'profil'];

  function show(sec) {
    if (SECTIONS.indexOf(sec) === -1) sec = 'dashboard';
    $$('.pz-acc__sec').forEach(function (s) {
      s.hidden = s.getAttribute('data-sec') !== sec;
    });
    $$('.pz-acc__navlink').forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('data-sec') === sec);
    });
    var mob = $('#pz-acc-mobnav');
    if (mob) mob.value = sec;
  }

  function current() {
    try { return new URLSearchParams(location.search).get('v') || 'dashboard'; }
    catch (e) { return 'dashboard'; }
  }

  function go(sec, push) {
    show(sec);
    if (push) {
      try { history.pushState({ v: sec }, '', '?v=' + sec); } catch (e) {}
    }
    root.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.pz-acc__navlink, .pz-acc__navjump');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    go(link.getAttribute('data-sec'), true);
  });

  var mobnav = $('#pz-acc-mobnav');
  if (mobnav) mobnav.addEventListener('change', function () { go(mobnav.value, true); });

  window.addEventListener('popstate', function () { show(current()); });
  show(current());

  /* ──────────── Historique ──────────── */

  var orders = [];
  try {
    var raw = $('#pz-acc-orders');
    if (raw) orders = JSON.parse(raw.textContent) || [];
  } catch (e) { orders = []; }

  function addToCart(items, btn) {
    if (!items.length) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch(R.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Ajout impossible');
        return j;
      });
    }).then(function () {
      if (btn) btn.textContent = 'Ajouté ✓';
      $$('.pz-cart-count').forEach(function (el) {
        el.textContent = (parseInt(el.textContent, 10) || 0) + items.length;
      });
      setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1500);
    }).catch(function (err) {
      alert(err.message || 'Une erreur est survenue.');
      if (btn) { btn.textContent = label; btn.disabled = false; }
    });
  }

  /* Recommander : réinjecte toutes les lignes d'une commande passée. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pz-acc__reorder');
    if (!btn) return;
    var name = btn.getAttribute('data-order');
    var order = orders.filter(function (o) { return o.name === name; })[0];
    if (!order) return;
    var items = order.items
      .filter(function (li) { return li.id; })
      .map(function (li) { return { id: li.id, quantity: li.q || 1 }; });
    addToCart(items, btn);
  });

  /* Export CSV d'une commande — même format que le modèle d'import de la
     commande rapide, donc réimportable tel quel pour servir de gabarit. */
  function csvCell(v) {
    var t = String(v == null ? '' : v);
    return /[";\r\n]/.test(t) ? '"' + t.replace(/"/g, '""') + '"' : t;
  }
  function orderToCsv(order) {
    var out = ['sku;quantite;libelle;marque'];
    (order.items || []).forEach(function (li) {
      out.push([csvCell(li.s || ''), csvCell(li.q || 0), csvCell(li.t || ''), csvCell(li.b || '')].join(';'));
    });
    return '\ufeff' + out.join('\r\n') + '\r\n';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pz-acc__csv');
    if (!btn) return;
    e.preventDefault();
    var name = btn.getAttribute('data-order');
    var order = orders.filter(function (o) { return o.name === name; })[0];
    if (!order) return;
    var blob = new Blob([orderToCsv(order)], { type: 'text/csv;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'prozone-' + String(name).replace(/[^\w.-]+/g, '-').replace(/^-+|-+$/g, '') + '.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
  });

  /* ──────────── Réassort : top références par quantité cumulée ──────────── */

  var host = $('#pz-reassort');
  if (host) {
    var agg = Object.create(null);
    orders.forEach(function (o) {
      (o.items || []).forEach(function (li) {
        if (!li.id) return;
        var k = String(li.id);
        if (!agg[k]) agg[k] = { id: li.id, qty: 0, t: li.t, b: li.b, s: li.s, p: li.p, u: li.u };
        agg[k].qty += (li.q || 0);
      });
    });

    var top = Object.keys(agg).map(function (k) { return agg[k]; })
      .sort(function (a, b) { return b.qty - a.qty; })
      .slice(0, 6);

    if (!top.length) {
      host.hidden = true;
      var empty = $('#pz-reassort-empty');
      if (empty) empty.hidden = false;
    } else {
      top.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'pz-acc__ritem';

        var body = document.createElement('div');
        body.className = 'pz-acc__rbody';
        if (it.b) {
          var brand = document.createElement('div');
          brand.className = 'pzb-brand';
          brand.textContent = it.b;
          body.appendChild(brand);
        }
        var title = document.createElement(it.u ? 'a' : 'div');
        title.className = 'pzb-title';
        title.style.display = 'block';
        title.textContent = it.t || '';
        if (it.u) title.href = it.u;
        body.appendChild(title);
        var ref = document.createElement('div');
        ref.className = 'pzb-ref';
        ref.textContent = (it.s ? 'Réf. ' + it.s + ' · ' : '') + 'commandé ' + it.qty + '×';
        body.appendChild(ref);

        var right = document.createElement('div');
        var price = document.createElement('div');
        price.className = 'pz-acc__rprice';
        price.textContent = money(it.p);
        right.appendChild(price);

        var step = document.createElement('div');
        step.className = 'pzb-stepper';
        step.innerHTML = '<button type="button" data-d="-1" aria-label="Diminuer">−</button>' +
                         '<input type="number" min="0" value="0" data-r-qty aria-label="Quantité">' +
                         '<button type="button" data-d="1" aria-label="Augmenter">+</button>';
        step.addEventListener('click', function (ev) {
          var b = ev.target.closest('button[data-d]');
          if (!b) return;
          var inp = $('[data-r-qty]', step);
          inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-d'), 10));
        });
        right.appendChild(step);

        row.appendChild(body);
        row.appendChild(right);
        row.dataset.variant = it.id;
        host.appendChild(row);
      });
    }
  }

  var addAll = $('.pz-acc__addall');
  if (addAll) {
    addAll.addEventListener('click', function () {
      var items = [];
      $$('.pz-acc__ritem').forEach(function (row) {
        var q = parseInt($('[data-r-qty]', row).value, 10) || 0;
        if (q > 0) items.push({ id: Number(row.dataset.variant), quantity: q });
      });
      if (!items.length) { alert('Choisissez au moins une quantité.'); return; }
      addToCart(items, addAll);
    });
  }
})();
